import React from 'react'
import PropTypes from 'prop-types'

const CourseMenuCourseLink = props => {
  const iconSelection = (archived, role) => {
    if (!archived) {
      if (role === 'instructor') {
        return <i className={`far fa-fw mr-2 color_teal fa-book-open`} />
      } else {
        return <i className={`far fa-fw mr-2 color_teal fa-book`} />
      }
    } else {
      if (role === 'instructor') {
        return (
          <i
            className={`far fa-fw mr-2 color_teal icon_color_verylightgray fa-book-open`}
          />
        )
      } else {
        return (
          <i
            className={`far fa-fw mr-2 color_teal icon_color_verylightgray fa-book`}
          />
        )
      }
    }
  }

  return (
    <React.Fragment>
      <a
        className="pl-2 d-block truncate-link-text"
        href={`/reader/web/${props.cnum}/`}
        role="menuitem"
      >
        {iconSelection(props.archived, props.role)}
        {props.title}
      </a>
    </React.Fragment>
  )
}

CourseMenuCourseLink.propTypes = {
  title: PropTypes.string,
  cnum: PropTypes.string,
  archived: PropTypes.bool,
  role: PropTypes.string,
}

export default CourseMenuCourseLink
